import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-personal-setting',
  templateUrl: './personal-setting.component.html',
  styleUrls: ['./personal-setting.component.scss']
})
export class PersonalSettingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
